import Vue from 'vue'
import store from './store'
import router from './router'
import App from './components/App'
import "swiper/swiper.min.css"
import "swiper/swiper-bundle.min.css"

new Vue({
  router,
  store,
  template: '<App/>',
  components: { App }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js